import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import BuyQrBlock from '../../components/Qr/BuyQr/BuyQrBlock'
import Button from '../../components/reusable/Buttons/Button'
import Subtitle from '../../components/reusable/Titles/Subtitle'
import Title from '../../components/reusable/Titles/Title'
import { setQrAmount } from '../../redux/slices/qr'
import { setCurrentTransport } from '../../redux/slices/select'

const BuyQr = () => {
  const navigate = useNavigate()
  const handleTickets = () => {
    navigate('tickets')
  }

  const dispatch = useDispatch()
  useEffect(() => {
    return () => {
      dispatch(setCurrentTransport())
      dispatch(setQrAmount())
    }
  }, [dispatch])

  return (
    <div className="buy_qr_page wrapper_1055">
      <Button title="QR-квитки" handler={handleTickets} className="btn_qr_tickets" />
      <Title title="Одноразові QR квитки" />
      <Subtitle title="Придбання QR-квитків для проїзду у громадському транспорті" />
      <BuyQrBlock />
    </div>
  )
}

export default BuyQr
